import Vue from 'vue';
import VueResource from 'vue-resource';
import VModal from 'vue-js-modal';
import Vuelidate from 'vuelidate';
import VueAnalytics from 'vue-analytics';
import $ from 'jquery';
import BandSearch from 'components/BandSearch';
import BandBookingForm from 'components/BandBookingForm';
import ModalLinkButton from 'components/ModalLinkButton';
import BandGallery from 'components/BandGallery';
import QuoteHistory from 'components/QuoteHistory';
import ForgotPasswordForm from 'components/ForgotPasswordForm';
import PopupMessage from 'components/PopupMessage';
import SignupForm from 'components/SignupForm';
import InvitationNotification from 'components/InvitationNotification';
import EmailQueueProcessor from 'components/EmailQueueProcessor';
import FeedbackModal from 'components/FeedbackModal';
import AllGigsModal from 'components/AllGigsModal';
import GigReviewForm from 'components/GigReviewForm';
import AllReviewsModal from 'components/AllReviewsModal';
import PostSuccessCallToAction from 'components/PostSuccessCallToAction';
import Config from 'modules/Config';
import Stars from 'components/Stars';
import RecommendedBands from 'components/RecommendedBands';
import { loadGoogleMaps } from './modules/GoogleMaps';

Vue.use(VueResource);
Vue.use(VModal);
Vue.use(Vuelidate);
// ToDo - how switch between prod and dev GA accounts?
Vue.use(VueAnalytics, {
    id: Config.google_analytics_account || 'XXXXXXXXXXXX'
});

// include jquery for legacy reasons :((
window.$ = $;

/* eslint-disable no-new */
new Vue({
    el: '#bb-app',
    components: {
        BandSearch,
        BandBookingForm,
        ModalLinkButton,
        BandGallery,
        QuoteHistory,
        ForgotPasswordForm,
        PopupMessage,
        SignupForm,
        InvitationNotification,
        EmailQueueProcessor,
        FeedbackModal,
        AllGigsModal,
        GigReviewForm,
        PostSuccessCallToAction,
        AllReviewsModal,
        Stars,
        RecommendedBands
    },
});

loadGoogleMaps();
